import React from 'react';
import { ContentfulLaunchTile } from '@jbhi-fi/apis/src/contentful/types';
import { Icon } from '@jbhi-fi/lanyard-ui/components/Icon';
import { IconTransformer } from './IconTransformer';
import { LaunchTileProps } from '../../LaunchTiles/LaunchTiles';
import { ContentThemePalette } from './ThemeTransformer';

type ToLaunchTilePropsOptions = {
  hoverPalette?: ContentThemePalette;
};

export abstract class LaunchTilesTransformer {
  static toLaunchTileProps = (entry: ContentfulLaunchTile, options: ToLaunchTilePropsOptions = {}): LaunchTileProps => {
    return {
      label: entry?.fields?.buttonLabel ?? '',
      icon: entry?.fields?.icon ? <Icon {...IconTransformer.toLazyIconProps(entry.fields.icon)} /> : <></>,
      url: entry?.fields?.buttonUrl ?? '',
      shouldOpenInNewWindow: entry?.fields?.shouldOpenInNewWindow,
      hoverPalette: options?.hoverPalette,
    };
  };
}
